import React, { useState } from 'react';
import { navigationLinks } from '../mock';

const Header = ({ onBooking, onSectionClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Styles for header animations
  const headerStyles = `
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateX(-50%) translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
    }
    .header-nav {
      animation: slideDown 0.8s ease-out forwards;
    }
    .nav-item {
      transition: color 0.3s ease, text-shadow 0.3s ease;
    }
    .nav-item:hover {
      color: #007bff;
      text-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
    }
  `;

  const scrollToSection = (path) => {
    if (path.startsWith('#')) {
      if (onSectionClick) {
        onSectionClick(path);
      } else {
        const element = document.querySelector(path);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <style>{headerStyles}</style>
      <nav className="fixed z-50 nav-floating bg-white h-20 md:h-24 lg:h-28 px-4 md:px-8 lg:px-10 flex justify-between items-center border border-white/10 header-nav">
      {/* Logo */}
      <a
        href="/"
        className="flex items-center flex-shrink-0"
        aria-label="SGS Global Media — Home"
        onClick={(e) => {
          e.preventDefault();
          if (onSectionClick) {
            onSectionClick('home');
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }}
      >
        <img
          src="/logo.png"
          alt="SGS Global Media logo"
          width={200}
          height={67}
          className="h-14 md:h-18 lg:h-20 xl:h-24 w-auto object-contain"
        />
      </a>

      {/* Desktop Navigation - Centered with more spacing */}
      <div className="hidden lg:flex items-center gap-12 xl:gap-16 absolute left-1/2 -translate-x-1/2">
        {navigationLinks.map((link, index) => (
          <button
            key={index}
            onClick={() => scrollToSection(link.path)}
            className="text-xs xl:text-sm font-bold uppercase tracking-[0.2em] text-slate-600 transition-colors whitespace-nowrap nav-item"
          >
            {link.label}
          </button>
        ))}
      </div>

      {/* CTA Button - Visible on desktop */}
      <button
        onClick={onBooking}
        className="hidden lg:block bg-[#007bff] text-white px-5 lg:px-8 py-3 lg:py-4 rounded-xl text-[10px] lg:text-xs font-black uppercase tracking-widest glow-button whitespace-nowrap flex-shrink-0"
      >
        Get Started
      </button>

      {/* Mobile Menu Button - BLACK ICON */}
      <button
        className="lg:hidden p-2 flex-shrink-0 bg-white rounded-lg shadow-md border border-slate-200"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <span className="relative block w-6 h-6">
          <span
            className={`absolute left-0 top-1/2 h-0.5 w-6 bg-black rounded transition-all duration-200 ${
              isMobileMenuOpen ? 'rotate-45 translate-y-0' : '-translate-y-2'
            }`}
          />
          <span
            className={`absolute left-0 top-1/2 h-0.5 w-6 bg-black rounded transition-all duration-200 ${
              isMobileMenuOpen ? 'opacity-0' : 'opacity-100'
            }`}
          />
          <span
            className={`absolute left-0 top-1/2 h-0.5 w-6 bg-black rounded transition-all duration-200 ${
              isMobileMenuOpen ? '-rotate-45 translate-y-0' : 'translate-y-2'
            }`}
          />
        </span>
      </button>

      {/* Mobile Navigation - BLACK DROPDOWN */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-black rounded-2xl shadow-2xl p-6 lg:hidden border border-gray-700 mx-2" style={{backgroundColor: '#020617'}}>
          <nav className="flex flex-col gap-4">
            {navigationLinks.map((link, index) => (
              <button
                key={index}
                onClick={() => scrollToSection(link.path)}
                className="text-white hover:text-[#007bff] transition-colors text-sm font-bold uppercase tracking-wider text-left py-2"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => {
                onBooking();
                setIsMobileMenuOpen(false);
              }}
              className="bg-[#007bff] text-white px-6 py-3 rounded-xl text-xs font-black uppercase tracking-widest mt-2 glow-button"
            >
              Get Started
            </button>
          </nav>
        </div>
      )}
    </nav>
    </>
  );
};

export default Header;